// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import letterReplyEntity from './entities/letter-reply.json';
import letterReplyMenu from '../pages/letter-reply/menu.json';
import letterReplyFullForm from '../pages/letter-reply/forms/full.json';
import letterReplyContextForm from '../pages/letter-reply/forms/context.json';
import letterReplyMiniForm from '../pages/letter-reply/forms/mini.json';
import letterReplyLookupForm from '../pages/letter-reply/forms/lookup.json';
import letterReplyTableView from '../pages/letter-reply/views/table.json';
import letterReplyCardsView from '../pages/letter-reply/views/cards.json';
import letterReplyCalendarView from '../pages/letter-reply/views/calendar.json';
import letterReplyDashboardView from '../pages/letter-reply/views/dashboard.json';

/** Тип запису «Відповідь на лист» зі сторінками пакета: меню, форми та подання з pages/letter-reply/. */
export const letterReplyDefinition: IRecordTypeDefinition = {
  ...letterReplyEntity,
  views: assembleViewSet({
      table: letterReplyTableView,
      cards: letterReplyCardsView,
      calendar: letterReplyCalendarView,
      dashboard: letterReplyDashboardView,
  }),
  form: letterReplyFullForm,
  forms: { full: letterReplyFullForm, context: letterReplyContextForm, mini: letterReplyMiniForm, lookup: letterReplyLookupForm },
  menu: letterReplyMenu,
} as IRecordTypeDefinition;
